module.exports = __webpack_public_path__ + "static/media/checkResultImg.67339f23.png";